module.exports = __webpack_public_path__ + "images/credits-holder-3d910d471ec0e65b4b7ab1b5af193656.svg";